import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type CourseCard } from '../api';
import { useSession } from '../session';

export function MyCourses() {
  const { user } = useSession();
  const [courses, setCourses] = useState<CourseCard[] | null>(null);

  useEffect(() => {
    void api.get<{ courses: CourseCard[] }>('/courses/mine').then((r) => setCourses(r.courses));
  }, []);

  if (!courses) return <p className="muted">Loading your courses…</p>;

  const inProgress = courses.filter((c) => c.enrollmentStatus !== 'completed');
  const done = courses.filter((c) => c.enrollmentStatus === 'completed');

  return (
    <>
      <h1 className="h1">Welcome back, {user?.firstName}</h1>
      {courses.length === 0 && <p className="muted">You have no courses yet. Your trainer will assign them.</p>}

      {inProgress.length > 0 && (
        <>
          <h2 className="h2">Continue</h2>
          <div className="cards">{inProgress.map((c) => <CourseTile key={c.id} c={c} />)}</div>
        </>
      )}

      {done.length > 0 && (
        <>
          <h2 className="h2">Completed</h2>
          <div className="cards">{done.map((c) => <CourseTile key={c.id} c={c} />)}</div>
        </>
      )}
    </>
  );
}

function CourseTile({ c }: { c: CourseCard }) {
  return (
    <Link to={`/courses/${c.id}`} className="card">
      <div className="card__cover" style={c.coverImagePath ? { backgroundImage: `url(${c.coverImagePath})` } : undefined}>
        {!c.coverImagePath && <span aria-hidden>◆</span>}
      </div>
      <div className="card__body">
        <h3>{c.name}</h3>
        <p className="muted">{c.unitCount} {c.unitCount === 1 ? 'lesson' : 'lessons'}</p>
        <div className="bar" aria-hidden><span style={{ width: `${c.completionPct}%` }} /></div>
        <p className="card__meta">
          {c.enrollmentStatus === 'completed'
            ? `Completed${c.score != null ? ` · ${c.score}%` : ''}`
            : `${c.completionPct}% done`}
        </p>
      </div>
    </Link>
  );
}
